import React, { useState, useEffect, useCallback, useMemo } from 'react';

import { TableSearchListdDef } from '~/componentslocal/'
import * as S from './styles'

import { isEmpty } from 'lodash'
import api from '~/services/api';
import qs from 'querystring';



export default function DetalhePosto(props) {

    const { data } = props
    const { visible } = props

    const [tanques, setTanques] = useState([])
    const [bicos, setBicos] = useState([])
    const [operadores, setOperadores] = useState([])

    useEffect(() => {
        if (!isEmpty(data)) {
            handleGetTanques()
            handleGetBicos()
            handleGetOperadores()
        }
    }, [props])
    const postoHeader = useMemo(() => [
        {
            id: 'post_cod_posto',
            label: 'Cód. Unidata'
        },
        {
            id: 'post_cod_posto_fca',
            label: 'Cód. Cliente'
        },
        {
            id: 'post_desc',
            label: 'Descrição'
        },
        {
            id: 'post_corredor',
            label: 'Corredor'
        },
        {
            id: 'poes_desc',
            label: 'Estoque'
        },
        {
            id: 'tipo',
            label: 'Tipo'
        },
        {
            id: 'post_st_reg',
            label: 'Ativo'
        }
    ], [])



    const handleGetTanques = useCallback(async () => {
        let params = {
            wherefield: 'POST_COD_POSTO',
            valuewherefield: data.post_cod_posto,
            typewherefield: 'EQUALS'
        }
        const response = await api.get('tanquefisico', {
            params: { ...params, pagesize: 99999 },
            paramsSerializer: (param) => qs.stringify(param),
        });


        if (!isEmpty(response.data.items)) {
            setTanques(response.data.items)
        }

    }, [])

    const tanquesHeader = useMemo(() => [
        {
            id: 'tafi_cod_tafi',
            label: 'Número'
        },
        {
            id: 'tafi_capacidade',
            label: 'Capacidade'
        },

    ]
        , [])



    const handleGetBicos = useCallback(async () => {
        let params = {
            wherefield: 'POST_COD_POSTO',
            valuewherefield: data.post_cod_posto,
            typewherefield: 'EQUALS'
        }
        const response = await api.get('bicosposto', {
            params: { ...params, pagesize: 99999 },
            paramsSerializer: (param) => qs.stringify(param),
        });

        if (!isEmpty(response.data.items)) {
            setBicos(response.data.items)
        }
    }, [])

    const bicosHeader = useMemo(() => [
        {
            id: 'bico_cod_bico',
            label: 'Núm.',
            align: 'center'
        },
        {
            id: 'bico_endereco',
            label: 'IP',
            align: 'center'
        },
        {
            id: 'biau_sw_ver_comp',
            label: 'SW_VER_COMP',
            align: 'center'
        },
        {
            id: 'biau_sw_dta_comp',
            label: 'SW_DTA_COMP',
            align: 'center'
        },
        {
            id: 'biau_sw_hora_comp',
            label: 'SW_HORA_COMP',
            align: 'center'
        },
        {
            id: 'biau_sw_versao_cnf',
            label: 'SW_VERSAO_CNF',
            align: 'center'
        },
        {
            id: 'biau_sw_ass_ram',
            label: 'SW_ASS_RAM',
            align: 'center'
        },
        {
            id: 'biau_sw_flag_inic',
            label: 'SW_FLAG_INIC',
            align: 'center'
        },
        {
            id: 'biau_sw_mac_address',
            label: 'SW_MAC_ADRESS',
            align: 'center'
        },
        {
            id: 'biau_nome_tca',
            label: 'NOME_TCA',
            align: 'center'
        },
    ], [])


    const handleGetOperadores = useCallback(async () => {
        let params = {
            wherefield: 'POST_COD_POSTO',
            valuewherefield: data.post_cod_posto,
            typewherefield: 'EQUALS'
        }
        const response = await api.get('operadoresposto', {
            params: { ...params, pagesize: 99999 },
            paramsSerializer: (param) => qs.stringify(param),
        });

        if (!isEmpty(response.data.items)) {
            setOperadores(response.data.items)
        }
    }, [])

    const operadoresHeader = useMemo(() => [
        {
            id: 'oper_cod_oper',
            label: 'Matrícula'
        },
        {
            id: 'oper_nome',
            label: 'Nome'
        }
    ], [])




    return (
        <>
            {visible && (
                <S.Wrapper>
                    <S.WrapperTables>
                        <TableSearchListdDef
                            title="Posto"
                            cells={postoHeader}
                            data={data}
                            size="xs"
                            paginate={3}
                            showCount
                            search
                        />
                    </S.WrapperTables>
                    <S.WrapperTables>
                        <TableSearchListdDef
                            title="Tanques"
                            cells={tanquesHeader}
                            data={tanques}
                            size="xs"
                            paginate={3}
                            showCount
                            search
                        />
                    </S.WrapperTables>
                    <S.WrapperTables>
                        <TableSearchListdDef
                            title="Bicos"
                            cells={bicosHeader}
                            data={bicos}
                            size="xs"
                            paginate={3}
                            showCount
                            search
                        />
                    </S.WrapperTables>
                    <S.WrapperTables>
                        <TableSearchListdDef
                            title="Operadores"
                            cells={operadoresHeader}
                            data={operadores}
                            size="xs"
                            paginate={3}
                            showCount
                            search
                        />
                    </S.WrapperTables>

                </S.Wrapper >
            )}

        </>




    );
}
